import { render, staticRenderFns } from "./accountRecord.vue?vue&type=template&id=c0499528"
import script from "./accountRecord.vue?vue&type=script&lang=js"
export * from "./accountRecord.vue?vue&type=script&lang=js"
import style0 from "./accountRecord.vue?vue&type=style&index=0&id=c0499528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports